module.exports = __webpack_public_path__ + "img/kristelkobrich.7a6da510.jpg";